import { format, isValid } from 'date-fns'

export function formatDate(value?: string, type = 'yyyy/MM/dd'): string {
  if (!value) return ''

  if (!isValid(new Date(value))) {
    return ''
  }

  return format(+new Date(value), type)
}

/**
 * formatUnixTimeStampToDate
 * @param unixTimeStamp
 * @param type
 * @return Date
 */
export function formatUnixTimeStampToDate(unixTimeStamp: number, type = 'yyyy/MM/dd') {
  if (!unixTimeStamp) return ''

  if (!isValid(new Date(unixTimeStamp * 1000))) {
    return ''
  }
  const dateTime = new Date(unixTimeStamp * 1000)
  const result = format(new Date(dateTime), 'yyyy/MM/dd')
  return result
}
